
export const AllStates = [
  { state_id: "AL", state_name: "Alabama" },
  { state_id: "AK", state_name: "Alaska" },
  { state_id: "AZ", state_name: "Arizona" },
  { state_id: "AR", state_name: "Arkansas" },
  { state_id: "CA", state_name: "California" },
  { state_id: "CO", state_name: "Colorado" },
  { state_id: "CT", state_name: "Connecticut" },
  { state_id: "DE", state_name: "Delaware" },
  { state_id: "FL", state_name: "Florida" },
  { state_id: "GA", state_name: "Georgia" },
  { state_id: "HI", state_name: "Hawaii" },
  { state_id: "ID", state_name: "Idaho" },
  { state_id: "IL", state_name: "Illinois" },
  { state_id: "IN", state_name: "Indiana" },
  { state_id: "IA", state_name: "Iowa" },
  { state_id: "KS", state_name: "Kansas" },
  { state_id: "KY", state_name: "Kentucky" },
  { state_id: "LA", state_name: "Louisiana" },
  { state_id: "ME", state_name: "Maine" },
  { state_id: "MD", state_name: "Maryland" },
  { state_id: "MA", state_name: "Massachusetts" },
  { state_id: "MI", state_name: "Michigan" },
  { state_id: "MN", state_name: "Minnesota" },
  { state_id: "MS", state_name: "Mississippi" },
  { state_id: "MO", state_name: "Missouri" },
  { state_id: "MT", state_name: "Montana" },
  { state_id: "NE", state_name: "Nebraska" },
  { state_id: "NV", state_name: "Nevada" },
  { state_id: "NH", state_name: "New Hampshire" },
  { state_id: "NJ", state_name: "New Jersey" },
  { state_id: "NM", state_name: "New Mexico" },
  { state_id: "NY", state_name: "New York" },
  { state_id: "NC", state_name: "North Carolina" },
  { state_id: "ND", state_name: "North Dakota" },
  { state_id: "OH", state_name: "Ohio" },
  { state_id: "OK", state_name: "Oklahoma" },
  { state_id: "OR", state_name: "Oregon" },
  { state_id: "PA", state_name: "Pennsylvania" },
  { state_id: "RI", state_name: "Rhode Island" },
  { state_id: "SC", state_name: "South Carolina" },
  { state_id: "SD", state_name: "South Dakota" },
  { state_id: "TN", state_name: "Tennessee" },
  { state_id: "TX", state_name: "Texas" },
  { state_id: "UT", state_name: "Utah" },
  { state_id: "VT", state_name: "Vermont" },
  { state_id: "VA", state_name: "Virginia" },
  { state_id: "WA", state_name: "Washington" },
  { state_id: "WV", state_name: "West Virginia" },
  { state_id: "WI", state_name: "Wisconsin" },
  { state_id: "WY", state_name: "Wyoming" }
];